import { atom } from 'jotai';
import { CurrencyCross, CurrencyExchangeRateMaybe } from '../../types';
import { Loadable } from '../../utils';
import { BaseCurrency } from '../../utils/instrumentUtils';

export type CurrencyExchangeRates = { [key: CurrencyCross]: CurrencyExchangeRateMaybe };

/**
 * Stores the real time currency exchange rates
 */
export const currencyExchangeRateRTAtom = atom<CurrencyExchangeRates>({
  [`${BaseCurrency}${BaseCurrency}=` as CurrencyCross]: Loadable.loaded({
    currencyCross: `${BaseCurrency}${BaseCurrency}=` as CurrencyCross,
    rateInHuf: 1,
    lastUpdated: new Date().toISOString(),
  }),
});
